<a
  [href]="sanitizedHref()"
  [target]="htmlTarget()"
  [rel]="relAttribute()"
  [attr.aria-label]="effectiveAriaLabel()"
  [ngClass]="buttonClasses()"
  (click)="onClick($event)"
  class="hx-link-button">
  <span class="hx-link-button__content">
    <span class="hx-link-button__label">
      <ng-content>{{ label() }}</ng-content>
    </span>
    @if (showIcon()) {
      <hx-icon svgIcon="box-arrow-up-right" class="hx-link-button__icon"></hx-icon>
    }
  </span>
</a>
